export default {
    methods: {
        getCategoriesByParent(parentId) {
            let children = this.categories.filter(c => (
                c.parent == parentId
            ));
            let ids = children.map(c => c.id)
            do {
                let foundCategories = this.categories.filter(c => ids.includes(c.parent))
                ids = foundCategories.map(c => c.id)
                children = children.concat(foundCategories)
            }
            while (ids.length > 0)
            return children
        },
    },

    computed: {
        groupedCategories() {
            let groupedCategories = []

            let parentCategories = this.categories.filter((c) => c.parent == 0);
            parentCategories.forEach(pc => {
                let children = this.getCategoriesByParent(pc.id).filter(c => c.acf.meta && c.acf.meta.filter_enabled)
                if (!children.length) return

                groupedCategories.push({ parent: pc, children: children })
            })

            return groupedCategories
        },
    }
};
